import script from "./SessionChatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionChatPage.vue?vue&type=script&setup=true&lang=js"

import "./SessionChatPage.vue?vue&type=style&index=0&id=79e4f99a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e4f99a"]])

export default __exports__